import { useTranslation } from 'react-i18next';

export default function ConnaitreQuartier() {
  const { t } = useTranslation('pintendre');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-5 md:mb-6 leading-tight">
              {t('quartier_h2')}
            </h2>
            <p className="text-sm md:text-base text-[#4A5568] leading-relaxed mb-4">
              {t('quartier_p1')}
            </p>
            <p className="text-sm md:text-base text-[#4A5568] leading-relaxed">
              {t('quartier_p2')}
            </p>
          </div>

          <div className="rounded-lg overflow-hidden h-[320px] md:h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Rural Quebec property with large lot and open countryside view, detached garage and workshop buildings, spacious green fields, country road in foreground, warm afternoon light, authentic Quebec countryside photography, earthy tones with slate blue distant horizon and copper autumn accents on trees"
              alt="Grande propriété champêtre à Pintendre, Lévis avec dépendances et garage"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              width="700"
              height="500"
            />
          </div>
        </div>
      </div>
    </section>
  );
}